import React from 'react';
import {useSvgToElements} from './useSvgToElements';

export const CheckMedium = (
  props: any
): React.ReactElement<React.ComponentProps<'svg'>> => {
  const svgProps = useSvgToElements({
    ...props,
    width: 13,
    height: 11,
    name: 'check-medium',
  });

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 11" {...svgProps}>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        d="M11 2L5.5 8.5 2 5"
      />
    </svg>
  );
};

export default CheckMedium;
